import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import './assets/css/global.scss';
import './assets/scss/styles.scss';
import './assets/css/index.scss';
import './assets/css/layout.css';
import './assets/css/objects.scss';
import './assets/css/typography.scss';
import 'slick-carousel/slick/slick.css';
import './assets/css/variables/main.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';

import appConfig from './app/config/appConfig';
import {initConfig} from './app/config/config';
import App from './app/containers/App/App';
import {amplitude} from './app/services/amplitude';
import log from './app/services/logger/log';
import {addReduxLoggerIfEnabled, configureStore} from './app/state/store';

const render = async () => {
    await initConfig();

    if (appConfig.getIsMarketInitialized()) {
        log.setLevel(appConfig.getLogLevel(), appConfig.getAwsLogLevel());
    }

    const store = configureStore();

    await addReduxLoggerIfEnabled();
    amplitude.initAmplitude();

    const root = ReactDOM.createRoot(document.getElementById('root'));

    root.render(
        // TODO: StrictMode brakes the app(useEffect() multiple call, etc.), check if possible to enable
        // <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
        // </React.StrictMode>
    );
};

render();
